// src/services/portainerService.js
import portainerApi from "./portainerAxios";

const DEFAULT_ENDPOINT_ID = 3;

// Basit normalize helper
const cleanName = (names) => {
    const n = Array.isArray(names) ? (names[0] || "") : (names || "");
    return n.replace(/^\//, "");
};

export const getPortainerHealth = async () => {
    try {
        // Portainer status endpoint
        const res = await portainerApi.get("/api/status");
        return res.data;
    } catch (error) {
        throw error.response?.data || { message: "Portainer health hatası" };
    }
};

export const listContainers = async (endpointId = DEFAULT_ENDPOINT_ID) => {
    try {
        const res = await portainerApi.get(
            `/api/endpoints/${endpointId}/docker/containers/json`,
            { params: { all: 1 } }
        );

        // İstenen format: containerId, name, status (+ state)
        const containers = (res.data || []).map((c) => ({
            type: "container",
            containerId: c.Id,
            name: cleanName(c.Names),
            image: c.Image,
            state: c.State,          // running/exited...
            status: c.Status,        // "Up 2 hours" vs
            replicaDesired: 1,
            replicaRunning: (c.State || "").toLowerCase() === "running" ? 1 : 0,
            serviceId: c.Labels?.["com.docker.swarm.service.id"] || null,
        }));

        return containers;
    } catch (error) {
        throw error.response?.data || { message: "Container listesi alınamadı" };
    }
};

export const listServices = async (endpointId = DEFAULT_ENDPOINT_ID) => {
    try {
        const res = await portainerApi.get(
            `/api/endpoints/${endpointId}/docker/services`,
            { params: { status: true } }
        );

        // Swarm yoksa genelde boş array döner (veya 503/500 olabilir)
        const services = (res.data || []).map((s) => {
            const desired =
                s?.Spec?.Mode?.Replicated?.Replicas ?? s?.ServiceStatus?.DesiredTasks ?? null;
            const running = s?.ServiceStatus?.RunningTasks ?? null;

            return {
                type: "service",
                serviceId: s.ID || s.Id || s.id,
                name: s?.Spec?.Name || "",
                image: s?.Spec?.TaskTemplate?.ContainerSpec?.Image || "",
                status:
                    running != null && desired != null
                        ? (running === desired ? "running" : "degraded")
                        : "unknown",
                replicaDesired: desired,
                replicaRunning: running || 0,
            };
        });

        return services;
    } catch (error) {
        // Swarm yoksa hata dönmesi normal olabilir; UI'de swarm kullanmıyorsan istersen burada boş dönelim
        // return [];
        throw error.response?.data || { message: "Service listesi alınamadı (Swarm yoksa normal olabilir)" };
    }
};

export const listWorkloads = async (endpointId = DEFAULT_ENDPOINT_ID) => {
    try {
        // İkisini paralel al
        const [containersRes, servicesRes] = await Promise.allSettled([
            listContainers(endpointId),
            listServices(endpointId),
        ]);

        const containers =
            containersRes.status === "fulfilled" ? containersRes.value : [];

        const services =
            servicesRes.status === "fulfilled" ? servicesRes.value : [];

        const errors = [];
        if (containersRes.status === "rejected")
            errors.push({ area: "containers", error: containersRes.reason });

        if (servicesRes.status === "rejected")
            errors.push({ area: "services", error: servicesRes.reason });

        // Tek listede birleştir
        return {
            endpointId,
            data: [...services, ...containers],
            errors,
        };
    } catch (error) {
        throw error.response?.data || { message: "Workloads alınamadı" };
    }
};
